<template>
  <div class="fullwidth ptop">
    <div class="zoom-flex">
      <div style="flex-grow:1">
        <div v-if="(!image.animation) && showimage">
          <img :src="imgsrc" style="width:100%" :alt="image.alt" >
        </div>
        <zoom-animation :image="image" :artist="artist" v-if="image.animation && showimage" autoplay />
      </div>
      <image-description-panel :artist="artist" :image="image" inpage />
    </div>
    <div class="similar">
      <div class="simhead">Similar illustrations by {{ firstName }} </div>
      <div class="news-matrix"> 
        <similar-panel v-for="item in similars" :key="item.image_id" :item="item" :artist="artist" v-on:click="clickSimilar" />
      </div>
    </div>
    <div class="similar">
      <div class="simhead">
        {{ firstName }}'s latest news
      </div>
      <div class="news-matrix">
        <news-panel v-for="item in articles" :key="item.news_id" :item="item" v-on:click="goStory(item)" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageDescriptionPanel from '@/components/panels/ImageDescriptionPanel'
import ZoomAnimation from '@/components/panels/ZoomAnimation.vue'
import NewsPanel from '@/views/news/NewsPanel.vue'
import SimilarPanel from '@/views/imagepage/SimilarPanel.vue'
// This is just to allowing sharing an image on social media and easily linking to it
export default {
  components: {
    ImageDescriptionPanel,
    ZoomAnimation,
    NewsPanel,
    SimilarPanel
  },
  props: {
    imageid: String,
    name: String
  },
  data () {
    return {
      artist: {},
      image: { detail: {}},
      articles: {},
      similars: [],
      showimage: false
    }
  },
  created () {
    if(this.imageid){
      if(isNaN(this.imageid)) {
        let route = this.$route.path.split('/')
        route.pop()
        this.$router.push(route.join('/'))
        
        return
      }
      this.showimage = false
      this.loadData()
    }
  },
  computed:{
    imgsrc: function () {
      if(this.image && this.image.url) {
        return this.$k.getZoomImage(this.image.url)
      }
      return ''
    },
    firstName: function () {
      if(this.artist.formatted_name) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    }
  },
  beforeDestroy () {
    this.$k.removeTwitterAndOgs()
    this.showimage = false
  },
  methods: {
    clickSimilar() {
      this.showimage = false
    },
    // should change this so it pulls the image using the artist id and image id
    // needs a server-side update
    // also need to make it so not found if no matching image
    getGallery(which) {
      let curl = this.image.galleries[which]
      return this.$store.state.galleries.find(el => { return el.url === curl })
    },
    loadData: async function () {
      
      this.showimage = false
      this.$k.removeNamedMeta('robots')
      const imid = Number(this.imageid)
      const res = await this.$apix.post('collections/images', { image_id: Number(imid) })
      if(res.data.length > 0) {
        
        this.image = res.data[0]
        this.showimage = true
        this.artist = await this.$store.dispatch('fetchArtistById', this.image.artist_id)
        if(!this.artist) {
          window.location = '/not-found'
        }
        let permalink = this.$k.getImagePermalink(this.image, this.artist)
        if(this.$route.path !== permalink) {
          this.$router.push(permalink)
          return
        }
        let src = this.imgsrc
        let video = false
        if(this.image.animation) {
          video = (!this.image.swf.endsWith('.gif'))
          src = this.getMetaUrl(this.image)
          
        }
        let mtitle = this.image.detail.title
        if(!mtitle) {
          mtitle = ''
          if(this.image.galleries.length > 0) {
            let gal = this.getGallery(0)
            if(gal) {
              mtitle += gal.name
            }
          }
          if(this.image.galleries.length > 1) {
            let gal = this.getGallery(1)
            if(gal) {
              mtitle += ' and ' + gal.name
            }
          }
        }
        if(mtitle) {
          mtitle += ' | '
        }
        if(this.artist.animation && this.image.animation) {
          
          mtitle += 'Animation by ' + this.artist.formatted_name
        }
        else {
          
          mtitle += 'Illustration by ' + this.artist.formatted_name
        }
        
        this.$k.setTwitterMetas(mtitle, src, video,  window.location.href, this.artist.formatted_name)
        document.title = mtitle
        // now get the news
        this.loadNewsStories()
        this.loadSimilar()
        
      }
      else {
        // image doesn't exist
        this.$k.goNotFound()
      }
    },
    async loadSimilar() {
      let r2 = await this.$apix.post('collections/random-images', { artist_id: this.image.artist_id })
      r2.data = r2.data.filter(el => el.image_id != this.imageid)
      this.similars = r2.data
    },
    async loadNewsStories() {
      let tag = this.$k.tagToUrl(this.artist.formatted_name)
      let r2 = await this.$apix.get('news/artist/random/bytag/' + tag)
      this.articles = r2.data
    },
    getMetaUrl(image) {
      if(image.video_url) {
        return image.video_url
      }
      let ext = image.swf.split('.').pop().toLowerCase()
      if((ext === 'mov')||(ext === 'flv')){
        return `${this.$k.imagebase}media/artist/${this.artist.portfolio_url}/${this.image.swf}.mp4`
      }
      return `${this.$k.imagebase}media/artist/${this.artist.portfolio_url}/${this.image.swf}`
    },
    goStory(item) {
      this.$ixr.push(item.permalink)
    }
  },
  watch: {
    '$route.path': function () {
      this.showimage = false
    },
    imageid: function () {
      if(this.imageid){
        this.loadData()
      }
    }
  }

}
</script>

<style scoped>


.zoom-flex{
  display:flex;
  justify-content:center;
  cursor:default;
  width:100%;
}

.text-area{
  margin-left:20px;
  max-width:600px;
  min-width:200px;
  width: 20vw;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
}


.ptop{
  padding-top:40px;
}

.simhead{
  font-size:28px;
  font-weight:500;
  margin-top:26px;
  margin-bottom:10px;
}

.news-matrix{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
}


</style>
